import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
const { TaskUrl } = Urls;

const path = name => `app/pages/todayStartTask/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().todayStartTask;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    let temp = [];
    for (let key in params) {
        if (params[key]) {
            temp.push(`${key}=${params[key]}`);
        }
    }
    temp = temp.join('&');
    return temp;

};
const formatPOSTParams = getState => {
    const state = getState().todayStartTask;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};

/**
 * 导出今日首次执行数据
 */
export const exportData = () => {
    return async () => {
        try{
            await request(TaskUrl.downLoadTodayStartTask, 'GET');
        } catch (e) {
            throw e;
        } finally {
        }
    };
};

/**
 * 获取今日首次执行数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
           // let result = await request(TaskUrl.todayStartTask, 'GET');
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(TaskUrl.todayStartTask, 'POST',formatPOSTParams(getState));
            let { list } = result;
            result.sort((a, b) => Date.parse(new Date(a.beginTime)) - Date.parse(new Date(b.beginTime)));
            console.log("list is :" + list);
            dispatch(actions.get(result));
            // dispatch(actions.changePagination({total: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};



// WEBPACK FOOTER //
// ./pages/task/todayStartTask/reducers.js